'use client';

import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import EditIcon from '@alltrails/denali/icons/Edit';
import useTrailEditToolbar from '@/hooks/useTrailEditToolbar';
import styles from './TrailStats.module.scss';

const AdminEditButton = () => {
  const intl = useIntl();
  const { openTrailEditToolbar } = useTrailEditToolbar();

  return (
    <IconButton
      className={styles.editIcon}
      icon={{ Component: EditIcon }}
      onClick={() => openTrailEditToolbar()}
      size="sm"
      title={intl.formatMessage({ defaultMessage: 'Edit' })}
      variant="primary"
    />
  );
};

export default AdminEditButton;
